// extracted by mini-css-extract-plugin
export default {"member":"UserCard_member__VkMCK","pic":"UserCard_pic__H-8vw","member_info":"UserCard_member_info__2NfAo","social":"UserCard_social__toRBR"};